var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',_vm._g(_vm._b({attrs:{"action":"#"}},'form',_vm.$attrs,false),_vm.$listeners),[_vm._t("fields")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }